'use client';

import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import useAnimateInOutComponent from '@alltrails/core/hooks/useAnimateInOutComponent';
import IconButton from '@alltrails/denali/components/IconButton';
import Chevron from '@alltrails/denali/icons/Chevron';
import styles from './ScrollToTopButton.module.scss';

const scrollThreshold = 400;

const ScrollToTopButton = () => {
  const intl = useIntl();
  const [isScrolled, setIsScrolled] = useState(false);
  const { isAnimating, isVisible, onAnimationEnd } = useAnimateInOutComponent(isScrolled);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > scrollThreshold);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible && !isAnimating) {
    return null;
  }

  return (
    <div
      className={classNames(styles.container, { [styles.isVisible]: isVisible, [styles.isAnimating]: isAnimating })}
      onAnimationEnd={onAnimationEnd}
    >
      <IconButton
        icon={{ Component: Chevron }}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        size="sm"
        title={intl.formatMessage({ defaultMessage: 'Scroll to top' })}
      />
    </div>
  );
};

export default ScrollToTopButton;
